<template>
  <!------------------------ Forecast ------------------------>
  <div id="forecast">
    <div id="forecastheader" class="container-fluid">
      <div class="row">
        <div class="text-left headertxt">
          <template v-if="sportForecastSelectedEvent">
            <span v-if="sportForecastSelectedEvent.tacapt">{{ sportForecastSelectedEvent.tacapt }}</span>
            <span v-else-if="sportForecastSelectedEvent.ta">{{ sportForecastSelectedEvent.ta }}</span>
            <span class="">-vs-</span> <!-- class=versus -->
            <span  v-if="sportForecastSelectedEvent.tbcapt">{{ sportForecastSelectedEvent.tbcapt }}</span>
            <span v-else-if="sportForecastSelectedEvent.tb">{{ sportForecastSelectedEvent.tb }}</span>
          </template>
        </div>
        <div class="action-button">
          <div class="glyphIcon-large secondary icon-refresh" title="Refresh" @click="getSportWager(true)"></div>
          <div class="glyphIcon-large secondary icon-close" title="Close" @click="closeForecast"></div>
        </div>
      </div>
    </div>
    <div id="forecastbody" class="container-fluid">
      {{ betAmount }}
      <div class="row waiting-bet">
        <div class="col-xs-6 text-left warningtext">
          <span style="padding-left: 5px;">
            <!-- <i class="glyphicon glyphicon-warning-sign"></i> -->
            <i class="glyphIcon primary lineCircle-primary icon-warning"></i>
            {{ sportForecastLang['FORECAST.LBL_WAIT_BET_TKT'] }} {{ wagerCount }}
        </span>
        </div>
        <div class="col-xs-6">
          <button class="btn btn-sm pull-right removebtn" @click="removeForecastList">{{ sportForecastLang['FORECAST.LBL_REMOVE'] }}</button>
        </div>
      </div>
      <div class="row betinfo-panel">
        <div class="col-xs-12">
          <template v-if="selectedForecastEvent || sportWaitingWagerList">
            <template v-if="selectedForecastEvent">
              <template v-if="selectedForecastEvent[ftPlyType]">
                <div class="plytyp-panel text-left" @click="showFT = !showFT">
                  <button class="trigger toggle-primary":class="{'icon-open' : showFT, 'icon-close' : !showFT}"></button>
                  <span style="line-height: 2.2;">{{ sportForecastLang['FORECAST.LBL_FT'] }}</span>
                </div>
                <div v-show="showFT">
                  <ul class="list-group betinfo-panel">
                    <template v-for="(bettyp, bettypKey) in selectedForecastEvent[ftPlyType]">
                      <li class="list-group-item text-left" v-for="(tbet, tbetKey) in bettyp">
                        <div class="pull-left col-sm-9">
                          <input type="checkbox" class="forecast-check" @change="chckBoxForecast" v-model="selectedForecastEvent[ftPlyType][bettypKey][tbetKey].check"/>
                          <span>{{ BetTypeLang[bettypKey]['caption'] }}</span> - <span v-html="computeTeamBet(tbet)"></span>&nbsp;
                          <template v-if="selectedForecastEvent"></template>
                          @&nbsp;
                          <h5 class="betinfo-odd">{{ getDecimalDisplay(tbet.odd) }}</h5>
                        </div>
                        <div class="pull-right col-sm-3">
                          <div class="pull-right glyphIcon icon-close" @click="removeForecastOdds(sportForecastSelectedEvent.eveid, ftPlyType, bettypKey, tbetKey)"></div>
                          <!-- <span class="pull-right betinfo-remove" @click="removeForecastOdds(sportForecastSelectedEvent.eveid, ftPlyType, bettypKey, tbetKey)"><i class="glyphicon glyphicon-remove"></i></span> -->
                          <span class="pull-right betinfo-amount">{{ tbet.betAmount | number(0) }}</span>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
                <div class="table-responsive" v-show="showFT">
                  <table class="table table-bordered forecast-table">
                    <thead>
                      <tr>
                        <th rowspan="2" class="away text-center">{{ sportForecastLang['FORECAST.LBL_AWAY'] }}</th>
                        <th colspan="5" class="home text-center">{{ sportForecastLang['FORECAST.LBL_HOME'] }}</th>
                      </tr>
                      <tr>
                        <template v-for="n in 5">
                          <th class="homescore text-center">{{ getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'a') }}</th>
                        </template>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="n in 5">
                        <td class="text-center">{{ getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b') }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 0 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0,rbsco: showRBScore(ftPlyType, getScoreDisplay( 0, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 0 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 1 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0,rbsco: showRBScore(ftPlyType, getScoreDisplay( 1, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 1 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 2 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0,rbsco: showRBScore(ftPlyType, getScoreDisplay( 2, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 2 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 3 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0,rbsco: showRBScore(ftPlyType, getScoreDisplay( 3, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 3 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 4 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0,rbsco: showRBScore(ftPlyType, getScoreDisplay( 4, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 4 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </template>
            <template v-if="selectedForecastEvent">
              <template v-if="selectedForecastEvent[firstHtPlyType]">
                <div class="plytyp-panel text-left" @click="showHT = !showHT">
                  <button class="trigger toggle-primary":class="{'icon-open' : showFT, 'icon-close' : !showFT}"></button>
                  <!-- <span class="glyphicon" :class="{'glyphicon-chevron-down' : showHT, 'glyphicon-chevron-right' : !showHT}"></span> -->
                  <span style="line-height: 2.2;">{{ sportForecastLang['FORECAST.LBL_HT'] }}</span>
                </div>
                <div v-show="showHT">
                  <ul class="list-group betinfo-panel">
                    <template v-for="(bettyp, bettypKey) in selectedForecastEvent[firstHtPlyType]">
                      <li class="list-group-item text-left" v-for="(tbet, tbetKey) in bettyp">
                        <div class="pull-left col-sm-9">
                          <input type="checkbox" class="forecast-check" @change="chckBoxForecast" v-model="selectedForecastEvent[firstHtPlyType][bettypKey][tbetKey].check"/><span>{{ BetTypeLang[bettypKey]['caption'] }}</span> - <span v-html="computeTeamBet(tbet)"></span> @ <h5 class="betinfo-odd">{{ tbet.odd | number(2) }}</h5>
                        </div>
                        <div class="pull-right col-sm-3">
                          <div class="pull-right glyphIcon icon-close" @click="removeForecastOdds(sportForecastSelectedEvent.eveid, firstHtPlyType, bettypKey, tbetKey)"></div>
                          <!-- <span class="pull-right betinfo-remove" ><i class="glyphicon glyphicon-remove"></i></span> -->
                          <span class="pull-right betinfo-amount">{{ tbet.betAmount | number(0) }}</span>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
                <div class="table-responsive" v-show="showHT">
                  <table class="table table-bordered forecast-table">
                    <thead>
                      <tr>
                        <th rowspan="2" class="away text-center">{{ sportForecastLang['FORECAST.LBL_AWAY'] }}</th>
                        <th colspan="5" class="home text-center">{{ sportForecastLang['FORECAST.LBL_HOME'] }}</th>
                      </tr>
                      <tr>
                        <template v-for="n in 5">
                          <th class="homescore text-center">{{ getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'a') }}</th>
                        </template>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="n in 5">
                        <td class="text-center">{{ getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b') }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 0 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay( 0, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 0 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 1 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay( 1, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 1 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 2 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay( 2, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 2 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 3 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay( 3, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 3 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 4 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay( 4, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 4 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </template>
            <template v-if="sportWaitingWagerList && !selectedForecastEvent">
              <template v-if="sportWaitingWagerList[1]">
                <div class="plytyp-panel text-left" v-show="showFT">
                  <span>{{ sportForecastLang['FORECAST.LBL_FT'] }}</span>
                </div>
                <div class="table-responsive" v-show="showFT">
                  <table class="table table-bordered forecast-table">
                    <thead>
                      <tr>
                        <th rowspan="2" class="away text-center">{{ sportForecastLang['FORECAST.LBL_AWAY'] }}</th>
                        <th colspan="5" class="home text-center">{{ sportForecastLang['FORECAST.LBL_HOME'] }}</th>
                      </tr>
                      <tr>
                        <template v-for="n in 5">
                          <th class="homescore text-center">{{ getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'a') }}</th>
                        </template>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="n in 5">
                        <td class="text-center">{{ getScoreDisplay( n - 1, sportForecastSelectedEvent, 'b') }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 0 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(ftPlyType, getScoreDisplay(0, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 0 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 1 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(ftPlyType, getScoreDisplay(1, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 1 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 2 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(ftPlyType, getScoreDisplay(2, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 2 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 3 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(ftPlyType, getScoreDisplay(3, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 3 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(ftPlyType, getScoreDisplay( 4 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(ftPlyType, getScoreDisplay(4, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(ftPlyType, getScoreDisplay( 4 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <template v-if="sportWaitingWagerList[2]">
                <div class="plytyp-panel text-left" v-show="showHT">
                  <span>{{ sportForecastLang['FORECAST.LBL_HT'] }}</span>
                </div>
                <div class="table-responsive" v-show="showHT">
                  <table class="table table-bordered forecast-table">
                    <thead>
                      <tr>
                        <th rowspan="2" class="away text-center">{{ sportForecastLang['FORECAST.LBL_AWAY'] }}</th>
                        <th colspan="5" class="home text-center">{{ sportForecastLang['FORECAST.LBL_HOME'] }}</th>
                      </tr>
                      <tr>
                        <template v-for="n in 5">
                          <th class="homescore text-center">{{ getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'a') }}</th>
                        </template>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="n in 5">
                        <td class="text-center">{{ getScoreDisplay( n - 1, sportForecastSelectedEvent, 'b') }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 0 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay(0, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 0 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 1 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay(1, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 1 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 2 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay(2, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 2 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 3 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay(3, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 3 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                        <td class="text-center forecast-wl" :class="{ngve : calcForecastWL(firstHtPlyType, getScoreDisplay( 4 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) < 0, rbsco: showRBScore(firstHtPlyType, getScoreDisplay(4, sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay(n - 1, sportForecastSelectedEvent, 'b')) }">{{ calcForecastWL(firstHtPlyType, getScoreDisplay( 4 , sportForecastSelectedEvent, 'a') + '_' + getScoreDisplay( n - 1 , sportForecastSelectedEvent, 'b')) | number(2) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </template>
          </template>
          <template  v-if="!switchEvent || (!selectedForecastEvent)">
            <div class="no-info" v-if="sportWaitingWagerList && (!sportWaitingWagerList[1] && !sportWaitingWagerList[2])">
              {{ sportForecastLang['FORECAST.LBL_NO_INFO'] }}
            </div>
          </template>
        </div>
        <div class="col-xs-12 note-info">
          <div class="title">{{ sportForecastLang['FORECAST.LBL_NOTE'] }}</div>
          <div class="txt" :class="{'hide-note': !showNote, 'show-note': showNote}">
            <span>{{ modifyNote() }}</span>
            <div class="smallBtn primary" :class="{'icon-arrow-down': !showNote, 'icon-arrow-up': showNote}" @click="showNote = !showNote"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
  } from 'vuex'

  import VueFilterNumber from '@/vue/filters/vue-filter-number'
  import EventBus from '@/vue/events/event-bus'
  import allBetMixin from '@/vue/mixins/allBet'
  import forecastCalculationMixin from '@/vue/mixins/forecastCalculation'
  import accounting from 'accounting'


  export default {
    mixins: [allBetMixin, forecastCalculationMixin],
    computed: {
      ...mapGetters([
        'BetTypeLang',
        'sportForecastLang',
        'sportForecastToggle',
        'sportForecastSelectedEvent',
        'betForm',
        'sportWaitingWagerList',
        'selectedMarket',
        'market',
      ]),
    },
    data() {
      return {
        showNote: false,
        forecastList: null,
        betAmount: null,
        selectedForecastEvent: null,
        showFT: true,
        showHT: true,
        waitingWagerList: [],
        wagerCount: 0,
        eventObj: null,
        switchEvent: true,
        firstShowForecast: true,
        timer: 5,
        timerId: null,
        token: window.token,
      }
    },
    watch: {
      'sportForecastSelectedEvent': {
        handler(val, oldVal) {
          if(this.selectedForecastEvent) {
            var selFcEve = this.selectedForecastEvent
            for(var pt=0; pt < Object.keys(selFcEve).length ; pt++) {
              var ptKey = Object.keys(selFcEve)[pt]
              if(ptKey != 'eveObj') {
                for(var bt=0; bt < Object.keys(selFcEve[ptKey]).length ; bt++) {
                  var btKey = Object.keys(selFcEve[ptKey])[bt]
                  for(var tbet=0; tbet < Object.keys(selFcEve[ptKey][btKey]).length ; tbet++) {
                    var tbetKey = Object.keys(selFcEve[ptKey][btKey])[tbet]
                    var eveid = selFcEve[ptKey][btKey][tbetKey].eveid
                    selFcEve[ptKey][btKey][tbetKey].rbscoa = this.$store.getters.sportForecastSelectedEvent.rbinfo['scoa']
                    selFcEve[ptKey][btKey][tbetKey].rbscob = this.$store.getters.sportForecastSelectedEvent.rbinfo['scob']
                    this.forecastList[eveid][ptKey][btKey][tbetKey] = this.getForecastInfo(this.forecastList, eveid, ptKey, btKey, tbetKey, {isWager: false})
                  }
                }
              }
            }
          }
        },
        deep: true,
      },
      'betForm': {
        handler(val, oldVal) {
          
          if(val.length > 0 && !this.$store.getters.betting.success){
            if(val[0]['eveid'] == this.sportForecastSelectedEvent.eveid) {
              this.firstShowForecast = false
              this.checkForecastExist(_.cloneDeep(val[0]))
              this.getSportWager()
              this.$forceUpdate()
              var data = {
                betForm: _.cloneDeep(this.$store.getters.betForm[0]),
                betAmount: this.$store.getters.sportMiniBet.betAmount
              }
              this.eventBusCalcForecast(data)
            }
          }
          if(this.firstShowForecast) {
            this.getSportWager()
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      getDecimalDisplay(value) {
          if(this.$store.getters.account.oddsType=='am'){
              return parseFloat(value).toFixed(0);
          }
          return parseFloat(value).toFixed(2);
      },
      chckBoxForecast () {
        this.$forceUpdate()
      },
      removeForecastOdds(eveid, ftPlyType, bettypKey, tbetKey) {
        var sportForecastList = this.$store.getters.sportForecastList
        this.$delete(sportForecastList[eveid][ftPlyType][bettypKey], tbetKey)
        //if bettype empty
        if(Object.keys(sportForecastList[eveid][ftPlyType][bettypKey]).length == 0) {
          this.$delete(sportForecastList[eveid][ftPlyType], bettypKey)
          //if playtype empty
          if(Object.keys(sportForecastList[eveid][ftPlyType]).length == 0) {
            this.$delete(sportForecastList[eveid], ftPlyType)
            //if event empty
            if(Object.keys(sportForecastList[eveid]).length == 1) {
              this.$delete(sportForecastList, eveid)
              //if forecast empty
              if(Object.keys(sportForecastList).length == 0) {
                sportForecastList = null
                this.selectedForecastEvent = null
              }
            }
          }
        }
        this.$store.commit('SPORTFORECAST_LIST', sportForecastList)
      },
      checkForecastExist (betForm) {
        var eveid = betForm.eventObj.eveid
        var eveObj = betForm.eventObj
        var plytyp = betForm.plyType
        var bettyp = betForm.betType
        var tbetcapt = betForm.tbetcapt
        var tbet = betForm.tbet
        var ta = betForm.ta
        var tb = betForm.tb
        var odd = betForm.odd

        var dual = betForm.dual ? '-' + betForm.dual : ''
        //check submatch bettype to form new tbet
        tbet += dual

        //_.unset(betForm, 'eventObj')
        this.forecastList = this.$store.getters.sportForecastList ? this.$store.getters.sportForecastList : {}
        //if no event, create new array
        if(!this.forecastList[eveid]) {
          this.forecastList[eveid] = {}
          this.forecastList[eveid][plytyp] = {}
          this.forecastList[eveid][plytyp][bettyp] = {}
          this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm)
        } else { //got event
          //if no plytyp, create new plytyp
          if(!this.forecastList[eveid][plytyp]) {
            this.forecastList[eveid][plytyp] = {}
            this.forecastList[eveid][plytyp][bettyp] = {}
            this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm)
          } else { //got plytyp
            //if no bettyp, create new bettyp
            if (!this.forecastList[eveid][plytyp][bettyp]) {
              this.forecastList[eveid][plytyp][bettyp] = {}
              this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm)
            } else { //got bettyp
              //if no tbet, create new tbet
              if(!this.forecastList[eveid][plytyp][bettyp][tbet]) {
                this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm)
              } else { //overwrite
                this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm)
              }
            }
          }
        }
        this.selectedForecastEvent = this.forecastList[eveid]
        this.selectedForecastEvent.eveObj = {
          eveid: eveObj.eveid,
          tacapt: eveObj.tacapt,
          tbcapt: eveObj.tbcapt,
        }
      },
      createForecastObj (eveid, plytyp, bettyp, tbet, betForm) {
        this.forecastList[eveid][plytyp][bettyp][tbet] = betForm
        this.forecastList[eveid][plytyp][bettyp][tbet].check = true
        this.forecastList[eveid][plytyp][bettyp][tbet].betAmount = 0
        this.$store.commit('SPORTFORECAST_LIST', this.forecastList)
      },
      removeForecastList() {
        if(this.selectedForecastEvent) {
          _.unset(this.forecastList, this.selectedForecastEvent.eveObj.eveid)
          this.$store.commit('SPORTFORECAST_LIST', this.forecastList)
          this.selectedForecastEvent = null
          this.$forceUpdate()
        }
      },
      closeForecast() {
        this.$store.commit('SPORTFORECAST_TOGGLE', false)
      },
      initForecastTable() {
        $('#forecast').css({
          'top': '60%',
          'left': '50%',
          'margin-left': '-200px',
          'margin-top': '-200px',
          // 'top':this.$store.getters.sportForecastWindowEvent.clientY,
          // 'left':this.$store.getters.sportForecastWindowEvent.clientX
        }).fadeIn('slow');
        $('#forecast').draggable({
          containment: '#contentsRight',
        })
      },
      getForecastInfo (list, eveid, plytyp, bettyp, tbet, args) {
        //calculate amount on the spot
        var bet_info = list[eveid][plytyp][bettyp][tbet]
        var hc = 4, ac = 4

        bet_info.odTypId = this.$store.getters.account.oddsType

        if( this.$store.getters.sportForecastSelectedEvent && this.$store.getters.sportForecastSelectedEvent.rbinfo ){
            hc = parseInt(this.$store.getters.sportForecastSelectedEvent.rbinfo['scoa']) >= 2 ? hc + parseInt(this.$store.getters.sportForecastSelectedEvent.rbinfo['scoa']) : hc;
            ac = parseInt(this.$store.getters.sportForecastSelectedEvent.rbinfo['scob']) >= 2 ? ac + parseInt(this.$store.getters.sportForecastSelectedEvent.rbinfo['scob']) : ac;
        }
        
        switch (bettyp.toString())
        {
          case this.onex2BetType:
          case this.ronex2BetType:
            return this.olc_1x2(bet_info, hc, ac);
            break;
          case this.hdpBetType:
          case this.rhdpBetType:
            return this.olc_ah(bet_info, hc, ac);
            break;
          case this.ouBetType:
          case this.rouBetType:
          case this.htgBetType:
          case this.rhtgBetType:
          case this.atgBetType:
          case this.ratgBetType:
            return this.olc_ou(bet_info, hc, ac);
            break;
          case this.oeBetType:
          case this.roeBetType:
            return this.olc_oe(bet_info, hc, ac);
            break;
          case this.csBetType:
          case this.rcsBetType:
            return this.olc_cs(bet_info, hc, ac);
            break;
          case this.tgBetType:
          case this.rtgBetType:
            return this.olc_tg(bet_info, hc, ac);
            break;
          case this.h1x2BetType:
          case this.rh1x2BetType:
            return this.olc_h1x2(bet_info, hc, ac);
            break;
          case this.bttsBetType:
          case this.rbttsBetType:
            return this.olc_btts(bet_info, hc, ac);
            break;
          case this.cshBetType:
          case this.rcshBetType:
            return this.olc_csh(bet_info, hc, ac);
            break;
          case this.twnBetType:
          case this.rtwnBetType:
            return this.olc_twn(bet_info, hc, ac);
            break;
          case this.wmBetType:
          case this.rwmBetType:
            return this.olc_wm(bet_info, hc, ac);
            break;
          default :
            return false;
          //default   : alert('error : ol_add() -> switch ->' + bet_info['bet_type']);
        }
      },
      eventBusCalcForecast (data) {
        if(data == null){
          this.removeForecastList()
          return
        }
        var eveid = data.betForm.eventObj.eveid
        var eveObj = data.betForm.eventObj
        var plytyp = data.betForm.plyType
        var bettyp = data.betForm.betType
        var tbetcapt = data.betForm.tbetcapt
        var tbet = data.betForm.tbet
        var ta = data.betForm.ta
        var tb = data.betForm.tb
        var odd = data.betForm.odd

        var dual = data.betForm.dual ? '-' + data.betForm.dual : ''
        //check submatch bettype to form new tbet
        tbet += dual
        
        // console.log(data)
        this.checkForecastExist(data.betForm, data.event)
        this.forecastList[eveid][plytyp][bettyp][tbet].betAmount = accounting.toFixed(data.betAmount, 0)

        //calculate amount on the spot
        this.forecastList[eveid][plytyp][bettyp][tbet] = this.getForecastInfo(this.forecastList, eveid, plytyp, bettyp, tbet, {isWager: false})

        this.selectedForecastEvent = this.forecastList[eveid]
        this.selectedForecastEvent.eveObj = {
          eveid: eveObj.eveid,
          tacapt: eveObj.tacapt,
          tbcapt: eveObj.tbcapt,
        }
        this.$forceUpdate()
      },
      getSportWager(refresh=false) {
        var selectedEvent = this.$store.getters.sportForecastSelectedEvent
        var params = {
          eveId: selectedEvent.eveid,
          isForecast: '1',
          token: refresh==true ? token.arr_5 : token.arr_2,
        }
     
        //is rb pass rb score
        if(selectedEvent.rbinfo) {
          params.scoa = selectedEvent.rbinfo.scoa
          params.scob = selectedEvent.rbinfo.scob
        }
        this.$ajax({
          method: 'get',
          url: 'sport-wager',
          data: params
        }).done(((res)=> {
          if(res.wFc) {
            this.waitingWagerList = res.wFc
            this.$store.commit('SPORTFORECAST_WAITINGLIST', res.wFc)
            this.wagerCount = res.wFc.ttl
            this.$forceUpdate()
          }
          if(this.market.inPlayMarket.key == this.selectedMarket) {
            this.timer = 5
            this.startTimer()
          }
        }).bind(this)).catch((errRes)=> {
          if(this.market.inPlayMarket.key == this.selectedMarket) {
            this.timer = 5
            this.startTimer()
          }
        })
      },
      startTimer() {
        if(this.timerId == null){
          this.timerId = setInterval(() => {
            if(this.timer - 1 < 0) {
              this.getSportWager()
            } else {
              this.timer -= 1;
            }
          },1000);
        }
      },
      clearTimer() {
        clearInterval(this.timerId)
        this.timerId = null
      },
      modifyNote() {
        var note1 = this.sportForecastLang['FORECAST.LBL_NOTE_INFO']
        var note2 = this.sportForecastLang['FORECAST.LBL_NOTE_INFO_2']

        return note1+', '+note2
      }
    },
    mounted() {
      this.initForecastTable()
      EventBus.$on('FORECAST_GETWAITINGLIST', ((data)=> {
        if(data == 'nodata'){
          this.getSportWager()
          return
        }
        if(data == null){
          this.selectedForecastEvent = null
          this.getSportWager()
          return
        }
        this.selectedForecastEvent = null
        if(this.forecastList && this.forecastList[data.eveid]) {
          this.selectedForecastEvent = this.forecastList[data.eveid]
          this.selectedForecastEvent.eveObj = {
            eveid: data.eveid,
            tacapt: data.tacapt,
            tbcapt: data.tbcapt,
          }
        }
        this.getSportWager()
      }).bind(this))
      EventBus.$on('SHOW_FORECAST', ((event)=> {
        this.initForecastTable()
      }).bind(this))
      EventBus.$on('FORECAST_CALC', ((data)=> {
        this.eventBusCalcForecast(data)
      }).bind(this))
      EventBus.$on('REMOVE_ALL_FORECAST', (()=> {
        this.removeForecastList()
      }).bind(this))
      if(this.market.inPlayMarket.key == this.selectedMarket) {
        this.startTimer()
      }
    },
    beforeDestroy() {
      EventBus.$off('SHOW_FORECAST')
      EventBus.$off('FORECAST_GETWAITINGLIST')
      EventBus.$off('FORECAST_CALC')
      this.clearTimer()
    },
  }
</script>
<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }
  @import "~@/styles/base/global";
  // @import "~@/styles/components/forecast";
</style>
<style lang="css">
  /* .betinfo-tsco {
    color: red;
  }
  .betinfo-hdp {
    font-weight: 600;
    color: #7c7c7c;
    font-size: 14px;
    
  }
  .betinfo-hdp.red {
    color: red;
  } */
</style>



// WEBPACK FOOTER //
// resources/wob/vue/components/forecast.vue